webpackJsonp([5],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCampaignTitle = exports.getCampaignContent = undefined;
	
	var _BLL = __webpack_require__(16);
	
	var action = _interopRequireWildcard(_BLL);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getCampaignContent = exports.getCampaignContent = function getCampaignContent(params, callback) {
	  return function (dispatch, getState) {
	    action.getCampaignContent(params, function (json) {
	      callback(json);
	    });
	  };
	};
	
	var getCampaignTitle = exports.getCampaignTitle = function getCampaignTitle(params, callback) {
	  return function (dispatch, getState) {
	    action.getCampaignTitle(params, function (json) {
	      callback(json);
	    });
	  };
	};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _redux = __webpack_require__(13);
	
	var _reactRouter = __webpack_require__(35);
	
	var _Search = __webpack_require__(63);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Footer = __webpack_require__(58);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _AnimationFrame = __webpack_require__(93);
	
	var _AnimationFrame2 = _interopRequireDefault(_AnimationFrame);
	
	var _index = __webpack_require__(43);
	
	var index = _interopRequireWildcard(_index);
	
	var _global = __webpack_require__(57);
	
	var global = _interopRequireWildcard(_global);
	
	var _campaign = __webpack_require__(209);
	
	var campaign = _interopRequireWildcard(_campaign);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Campaign = function (_React$Component) {
	  _inherits(Campaign, _React$Component);
	
	  function Campaign(props) {
	    _classCallCheck(this, Campaign);
	
	    var _this = _possibleConstructorReturn(this, (Campaign.__proto__ || Object.getPrototypeOf(Campaign)).call(this, props));
	
	    _this.state = {
	      currentComponentFixedTop: null,
	      currentComponentFixedRight: null,
	      currentComponentFooter: null,
	      componentPopup: null,
	
	      addToCartPopup: null,
	
	      currentComponentFetchHtml: null,
	      currentComponentFetchTitle: null
	    };
	    _this.animationControl = new _AnimationFrame2.default();
	    return _this;
	  }
	
	  _createClass(Campaign, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var campaign = this.props.campaign;
	      /**
	       * Require Fixed Top Right
	       */
	      // match
	
	      var _pathname = _reactRouter.browserHistory.getCurrentLocation().pathname;
	      var _proId = _reactRouter.browserHistory.getCurrentLocation().query.pro_id || null;
	      if (_pathname.match(/^\/campaign\/.+\/$/)) {
	        var params = {
	          'pathname': _pathname
	        };
	        if (_proId) {
	          params = {
	            'pathname': _pathname,
	            'pro_id': _proId
	          };
	        }
	        campaign.getCampaignContent(params, function (callback) {
	          var results = callback.results;
	          var htmlDOM = results.htmlDOM;
	
	          if (!htmlDOM) {
	            window.location.href = "/error";
	            return false;
	          }
	          _this2.setState({
	            currentComponentFetchHtml: _react2.default.createElement('div', { id: 'campaign', dangerouslySetInnerHTML: { __html: htmlDOM } })
	          }, function () {
	            setTimeout(function () {
	              $('#campaign script').each(function forEachScript() {
	                var script = $(this).text();
	                if (script.includes("proImg")) {
	                  var editScript = script.replaceAll('\'+val.skuPic2+\'', 'https://ssl1.sephorastatic.cn/soa/public/images/preload180509.png"  class="sep_lazyload" data-original="\'+val.skuPic2+\'');
	                  editScript = editScript.replaceAll('loading(data);', '\n                  loading(data);\n                  $("img.sep_lazyload").lazyload({\n                    effect: "fadeIn",\n                    placeholder: "https://ssl1.sephorastatic.cn/soa/public/images/preload180509.png",\n                    skip_invisible : true\n                  });\n                ');
	                  window.eval(editScript);
	                } else {
	                  window.eval(script);
	                }
	              });
	            }, 500);
	          });
	        });
	      } else {
	        window.location.href = "/error";
	      }
	
	      window.addEventListener('resize', this.handleResize.bind(this));
	      window.addEventListener('scroll', this.handleScroll.bind(this));
	
	      // 获取浏览器的尺寸
	      this.handleFirstGet.bind(this)();
	    }
	  }, {
	    key: 'handleFirstGet',
	    value: function handleFirstGet() {
	      var global = this.props.global;
	
	      global.getGlobalWidth(window.innerWidth);
	      global.getGlobalHeight(window.innerHeight);
	      global.getGlobalScroll(document.body.scrollTop || document.documentElement.scrollTop);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      var global = this.props.global;
	
	      this.animationResize = this.animationControl.callRequestAnimationFrame(function () {
	        global.getGlobalWidth(window.innerWidth);
	        global.getGlobalHeight(window.innerHeight);
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(e) {
	      var global = this.props.global;
	
	      this.animationScroll = this.animationControl.callRequestAnimationFrame(function () {
	        global.getGlobalScroll(document.body.scrollTop || document.documentElement.scrollTop);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize.bind(this));
	      window.removeEventListener('scroll', this.handleScroll.bind(this));
	      this.animationControl.callCancelAnimationFrame(this.animationResize);
	      this.animationControl.callCancelAnimationFrame(this.animationScroll);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var site = [],
	          M_Search = _react2.default.createElement(_Search2.default, { _Async: true, key: 'search' }),
	          currentComponentFooter = _react2.default.createElement(_Footer2.default, { _View: true, key: 'Footer' });
	      site.push(M_Search);
	      site.push(this.state.currentComponentFetchHtml);
	      site.push(currentComponentFooter);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'site' },
	        site
	      );
	    }
	  }]);
	
	  return Campaign;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    _global: state.global
	  };
	}, function (dispatch) {
	  return {
	    index: (0, _redux.bindActionCreators)(index, dispatch),
	    global: (0, _redux.bindActionCreators)(global, dispatch),
	    campaign: (0, _redux.bindActionCreators)(campaign, dispatch),
	    dispatch: dispatch
	  };
	})(Campaign);

/***/ })

});


// WEBPACK FOOTER //
// 5.soa/bundle/5_317b6ca171ecdf9ca351.js